module.exports = __webpack_public_path__ + "static/media/nigel-2.da069300.jpg";